export default class MobileNav {
    constructor({
        closeSelector = '[data-mobile-nav-close]',
        toggleSelector = '.mobile-nav-toggle',
        openClass = 'mobile-nav-is-open',
        rootElement = document.documentElement
    } = {}) {
        this.toggleButton = document.querySelector(toggleSelector);
        this.root = rootElement;
        this.openClass = openClass;
        this.closeEls = document.querySelectorAll(closeSelector);

        if (!this.toggleButton) return;

        this.handleToggle = this.handleToggle.bind(this);
        this.handleKeydown = this.handleKeydown.bind(this);

        // Update when resizing
        window.addEventListener('resize', () => {
            if (window.innerWidth >= 768 && this.root.classList.contains(this.openClass)) {
                this.close();
            }
        });

        // Close nav when clicking on a close button
        this.closeEls.forEach(el => el.addEventListener('click', () => {
            this.close();
        }));

        this.init();
    }

    handleToggle() {
        const isOpen = this.root.classList.toggle(this.openClass);
        this.toggleButton.setAttribute('aria-expanded', isOpen);
    }

    handleKeydown(e) {
        if (e.key === 'Escape' && this.root.classList.contains(this.openClass)) {
            this.close();
        }
    }

    open() {
        this.root.classList.add(this.openClass);
        this.toggleButton.setAttribute('aria-expanded', 'true');
    }

    close() {
        console.log(this.root);
        this.root.classList.remove(this.openClass);
        this.toggleButton.setAttribute('aria-expanded', 'false');
    }

    init() {
        this.toggleButton.addEventListener('click', this.handleToggle);
        document.addEventListener('keydown', this.handleKeydown);
    }

    destroy() {
        this.toggleButton.removeEventListener('click', this.handleToggle);
        document.removeEventListener('keydown', this.handleKeydown);
    }
}
